(() => {
  const timers = new WeakMap();
  const requestIds = new WeakMap();
  const defaultLists = new WeakMap();

  async function queryAlgolia(appId, apiKey, indexName, query, league) {
    const filters = [league && `league:"${league}"`, 'published:true'].filter(Boolean).join(' AND ');
    try {
      const res = await fetch(`https://${appId}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-Application-Id': appId,
          'X-Algolia-API-Key': apiKey,
        },
        body: JSON.stringify({ query, filters, hitsPerPage: 100 }),
      });
      const data = await res.json();
      return data.hits ?? [];
    } catch {
      return [];
    }
  }

  function renderHits(list, hits) {
    list.innerHTML = hits
      .map(
        (hit) => `
        <li>
          <a
            href="${hit.url ? hit.url : `/collections/${hit.team_tag}`}"
            class="flex items-center gap-3.5 py-3.5 pr-3.5 text-sm border-b border-silver text-dove-grey hover:text-primary-dark transition-all ease-in"
          >
            ${hit.logo ? `<img src="${hit.logo}" alt="${hit.logo_alt || ''}" class="w-4 h-4 object-contain shrink-0 mr-2">` : ''}
            <span class="capitalize">${(() => {
              const base = hit.name.replace(/-/g, ' ').toLowerCase();
              const override = hit.override;
              if (!override) return base;
              return base.replace(new RegExp(override, 'i'), `<span style="text-transform:none">${override}</span>`);
            })()}</span>
          </a>
        </li>
      `
      )
      .join('');
  }

  function getList(input, league) {
    const selector = `[data-teams-list="${league}"]`;
    const panel = input.closest('[data-nav-sub-content], [data-mobile-panel]');
    return panel?.querySelector(selector) || document.querySelector(selector);
  }

  function syncClearButton(input) {
    const button = input.parentElement?.querySelector('[data-nav-team-search-clear]');
    if (!button) return;
    const hasValue = input.value.length > 0;
    const toggleIcon = (icon, visible) => {
      icon?.classList.toggle('block', visible);
      icon?.classList.toggle('hidden', !visible);
    };
    toggleIcon(button.querySelector('[data-nav-team-search-icon]'), !hasValue);
    toggleIcon(button.querySelector('[data-nav-team-search-clear-icon]'), hasValue);
    button.setAttribute('aria-label', hasValue ? 'Clear team search' : 'Search teams');
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-nav-team-search-clear]');
    if (!button) return;

    const input = button.parentElement.querySelector('input[name="team-search"]');
    if (!input) return;

    if (input.value) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    input.focus();
  });

  document.addEventListener('input', (e) => {
    const input = e.target;
    if (input.name !== 'team-search') return;

    clearTimeout(timers.get(input));
    syncClearButton(input);

    const { appId, apiKey, teamsIndex, league } = {
      appId: input.dataset.appId,
      apiKey: input.dataset.apiKey,
      teamsIndex: input.dataset.teamsIndex,
      league: input.dataset.league,
    };

    if (!appId || !teamsIndex) return;

    const list = getList(input, league);
    if (!list) return;

    // Cache the predefined (Liquid-rendered) team order before the first search replaces it
    if (!defaultLists.has(list)) defaultLists.set(list, list.innerHTML);

    // Invalidate any in-flight request so a stale response can't overwrite the list
    const requestId = (requestIds.get(input) || 0) + 1;
    requestIds.set(input, requestId);

    const query = input.value.trim();

    if (!query) {
      list.innerHTML = defaultLists.get(list);
      return;
    }

    timers.set(
      input,
      setTimeout(async () => {
        const hits = await queryAlgolia(appId, apiKey, teamsIndex, query, league);
        if (requestIds.get(input) !== requestId) return;
        renderHits(list, hits);
      }, 300)
    );
  });
})();
